module.exports = __webpack_public_path__ + "img/Day3_final.c2c2103c.jpg";